import Banner from "../../components/banner/Banner";
import { Label, Select, Textarea, TextInput } from "flowbite-react";
import { HiMail } from "react-icons/hi";
import { useFormik } from "formik";
import { object, string } from "yup";
import { validTopics } from "../../services/utils/topicsFormContact/topics";
import { sendContactForm } from "../../services/callAPI/toContactForm";
import { useState } from "react";
import ValidToast from "../../components/toasts/ValidToast";
import UnvalidToast from "../../components/toasts/UnvalidToast";
import { cleanInputValue } from "../../services/hooks/sanitizeValue/cleanInputValue";
import { isSanitizeEmailValue, isSanitizeMessageContactValue } from "../../services/hooks/sanitizeValue/isSanitizeValue";
import { Helmet } from "react-helmet-async";

function ContactPage(props: { isConnect: boolean }) {
  const [isShowValidToast, setIsshowValidToast] = useState<boolean>(false);
  const [isShowUnValidToast, setIsShowUnValidToast] = useState<boolean>(false);
  const [messageToast, setmessageToast] = useState<string | undefined>(undefined);

  //set validation schema with Yup
  const registerSchema = object({
    topic: string()
      .oneOf(validTopics, "L'objet de votre message doit être sélectionné dans la liste")
      .required("Sélectionnez l'objet de votre message"),
    email: string()
      .trim()
      .email(`Doit être un email valide`).min(5, "L'email doit comporter au moins 5 caractères").max(254, "L'email ne peut pas dépasser 50 caractères")
      .test("is-email-valid", "l'email contient des caractères non-imprimables", (value) => isSanitizeEmailValue(value))
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,  // Expression régulière pour filtrer les domaines invalides
        "Le domaine de l'email doit être valide"
      )
      .test(//check if domain name is valid to way strict
        "is-valid-domain",
        "Le domaine de l'email est invalide",
        (value) => {
          if (!value) return false;
          const domainPattern = /^[^\s@]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
          return domainPattern.test(value);
        }
      ).required(`Veuillez renseigner votre adresse mail`),
    msg: string()
      .trim()
      .min(5, "Le message doit comporter au moins 5 caractères")
      .max(1000, "Le message ne doit pas dépasser 1000 caractères")
      .test(
        "is-message-valid",
        "Le message contient des caractères interdits",
        (value) => isSanitizeMessageContactValue(value)
      )
      .required("Veuillez renseigner votre message"),
  })

  //set formik
  const { handleSubmit, handleChange, errors, touched, isSubmitting, values, resetForm, setFieldValue } = useFormik({
    initialValues: {
      topic: "",
      email: "",
      msg: ""
    },
    validationSchema: registerSchema,
    onSubmit: async values => {
      try {
        //call api
        const { message } = await sendContactForm(values);
        setmessageToast(message);
        setIsshowValidToast(true);

      } catch (error) {
        // Gestion des erreurs API
        if (error instanceof Error) {
          setmessageToast(error.message);
          setIsShowUnValidToast(true);
        } else {
          setmessageToast("Une erreur est survene.");
          setIsShowUnValidToast(true);
        }
      } finally {
        resetForm();
        setmessageToast(undefined);
      }
    }
  })

  return (
    <>
      {/* === Helmet for SEO === */}
      <Helmet>
        <title>Contact – Cemade</title>
        <meta name="description" content="Contacte l’équipe Cemade pour toute question ou partenariat." />
      </Helmet>

      {isShowValidToast && <ValidToast message={messageToast} onClose={() => setIsshowValidToast(false)} />}
      {isShowUnValidToast && <UnvalidToast message={messageToast} onClose={() => setIsShowUnValidToast(false)} />}

      <section id="section-contact" className="flex flex-col h-full">
        <Banner isConnect={props.isConnect} showBtnHome={true} />

        <h1 className="font-medium p-4">Contacte  nous via ce formulaire </h1>

        <form
          className="flex w-1/2 flex-col gap-4 flex-grow justify-around ml-auto mr-auto"
          onSubmit={handleSubmit}
        >
          <div className="max-w-md">
            <div className="mb-2 block text-start">
              <Label htmlFor="topic">Indique l'objet de ton message</Label>
            </div>
            <Select id="topic" name="topic" value={values.topic} onChange={handleChange}>
              <option value="">Sélectionne un sujet</option>
              <option value="Suggestions d'ajout de service / besoin">Suggestions d'ajout de service / besoin</option>
              <option value="Mon compte">Mon compte</option>
              <option value="Mon profil">Mon profil</option>
              <option value="Abonnement">Abonnement</option>
              <option value="Mes demandes de troc">Mes demandes de troc</option>
              <option value="Mes propositions de troc">Mes propositions de troc</option>
              <option value="Mes éléments d'échange">Mes éléments d'échange</option>
              <option value="Autre">Autre</option>
            </Select>
            {errors.topic && touched.topic && <div className="text-red-500">{errors.topic}</div>}
          </div>

          <div>
            <div className="mb-2 block">
              <Label htmlFor="email">Ton email</Label>
            </div>
            <TextInput id="email" name="email" type="email" placeholder="john@doe.com" icon={HiMail} onChange={handleChange} value={values.email} />
            {errors.email && touched.email && <div className="text-red-500">{errors.email}</div>}
          </div>

          <div>
            <div className="mb-2 block">
              <Label htmlFor="msg">Ton message</Label>
            </div>
            <Textarea
              id="msg"
              name="msg"
              rows={4}
              onChange={(e) => {
                const cleaned = cleanInputValue(e.target.value); // 🧼 Nettoyage automatique
                setFieldValue('msg', cleaned); // ⛳ On stocke directement la version propre
              }} value={values.msg}
            />
            {errors.msg && touched.msg && <div className="text-red-500">{errors.msg}</div>}
          </div>

          <div>
            <button
              type="submit"
              style={{ backgroundColor: '#335C67', color: 'white' }}
              className="rounded-md w-auto p-2"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Envoie en cours..." : "Envoyer"}
            </button>
          </div>
        </form>
      </section>
    </>
  )
}
export default ContactPage;